import * as yup from "yup";
import { GetErrorObject } from "../Utils";

export const UnitSchema = yup.object().shape({
  Unit: yup
    .string()
    .transform((value) => value || "")
    .required("Unit Name is required."),
  UnitTypeId: yup
    .string()
    .transform((value) => value || "")
    .required("Type is required."),
  UnitMake: yup
    .string()
    .transform((value) => value || "")
    .required("Make is required."),
  UnitMakeId: yup
    .string()
    .transform((value) => value || "")
    .required("Model is required."),
});

export function ValidateUnit(input) {
  return new Promise(async function (resolve, reject) {
    try {
      UnitSchema.validate(input, { abortEarly: false })
        .then(function () {
          const data = {
            Unit: {
              ...input,
            },
          };
          resolve({ data });
        })
        .catch(function (err) {
          const errors = GetErrorObject(err);
          resolve({ errors });
        });
    } catch (e) {
      reject(e);
    }
  });
}
